<template>
    <li class="col-span-1 divide-y divide-gray-200 rounded-lg bg-white shadow">
        <div class="flex w-full items-center justify-between space-x-6 p-6">
            <div class="flex-1 truncate">
                <div class="flex items-center space-x-3">
                    <div>
                        <h3 class="truncate text-sm font-medium text-gray-900">{{ operative.name }}</h3>
                        <a href="#" class="text-brand" v-if="this.canOpenNotes" @click.prevent="showNotesField()">Add
                            Notes</a>
                    </div>
                </div>
            </div>
            <img class="h-10 w-10 flex-shrink-0 rounded-full bg-gray-300" :src="operative.avatar" alt="">
        </div>
        <div v-if="canConfirmPresence">

            <!--        Allow notes to be logged since this is definitely has a register object-->
            <div v-if="showNote" class="p-6 border-b-2 border-gray-200">
                <textarea class="focus:border-gray-400 rounded border-gray-200" ref="notesarea" @focusout="noteFinished"
                          v-model="operative.note"></textarea>
            </div>
            <div class="-mt-px flex divide-x divide-gray-200">
                <div class="flex w-0 flex-1">
                    <a
                        href="#"
                        @click.prevent="markAbsent"
                        class="relative -mr-px inline-flex w-0 flex-1 items-center justify-center rounded-bl-lg border border-transparent py-4 text-sm font-medium"
                        :class="!operative.was_absent ? 'text-gray-700 hover:bg-red-100 hover:text-red-600' : 'bg-red-200 text-red-700 hover:text-red-700'"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                             stroke="currentColor"
                             class="h-5 w-5"
                             :class="!operative.was_absent ? 'text-gray-500' : ''"
                        >
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
                        </svg>
                        <span class="ml-3">Absent</span>
                    </a>
                </div>
                <div class="-ml-px flex w-0 flex-1">
                    <a
                        href="#"
                        @click.prevent="markPresent"
                        class="relative inline-flex w-0 flex-1 items-center justify-center rounded-br-lg border border-transparent py-4 text-sm font-medium"
                        :class="!operative.was_present ? 'text-gray-700 hover:bg-green-100 hover:text-green-600' : 'bg-green-200 text-green-700 hover:text-green-700'"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                             stroke="currentColor"
                             class="w-5 h-5"
                             :class="!operative.was_present ? 'text-gray-500' : ''"
                        >
                            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
                        </svg>
                        <span class="ml-3">Present</span>
                    </a>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
export default {
    props: {
        operative: Object,
        canConfirmPresence: Boolean,
        item: Object
    },
    data() {
        return {
            noteDisplay: false
        }
    },
    computed: {
        showNote() {
            if (this.operative.pending_confirmation) {
                return false
            }

            if (this.operative.note) {
                return true
            }

            if (this.noteDisplay) {
                return true
            }


            this.noteFinished()

            return false
        },
        canOpenNotes() {
            if (this.operative.pending_confirmation) {
                return false
            }

            if (this.operative.note) {
                return false
            }

            if (this.noteDisplay) {
                return false
            }

            // At this point there's no note and they are able to open notes
            return true
        }
    },
    methods: {
        showNotesField() {
            this.noteDisplay = true
            this.$nextTick(() => {
                this.$refs.notesarea.focus()
            })
        },
        noteFinished() {
            this.operative.saveNote()

            if (!this.operative.note) {
                this.noteDisplay = false
            }
        },
        async markAbsent() {
            await this.operative.markOperativeAbsent(this.item)
        },
        async markPresent() {
            await this.operative.markOperativePresent(this.item)
        }
    },
}
</script>
